import ButtonRoot from './ButtonRoot';
import ButtonIcon from './ButtonIcon';
import ButtonText from './ButtonText';

const ButtonVariant = {
  Root: ButtonRoot,
  Icon: ButtonIcon,
  Text: ButtonText,
};

export default ButtonVariant;
